var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2056 7.2105C13.8949 4.18117 14.7389 2.6665 16.0016 2.6665C17.2643 2.6665 18.1083 4.18117 19.7976 7.2105L20.2349 7.9945C20.7149 8.85584 20.9549 9.2865 21.3283 9.5705C21.7016 9.8545 22.1683 9.95984 23.1016 10.1705L23.9496 10.3625C27.2296 11.1052 28.8683 11.4758 29.259 12.7305C29.6483 13.9838 28.5309 15.2918 26.2949 17.9065L25.7163 18.5825C25.0816 19.3252 24.7629 19.6972 24.6203 20.1558C24.4776 20.6158 24.5256 21.1118 24.6216 22.1025L24.7096 23.0052C25.0469 26.4945 25.2163 28.2385 24.1949 29.0132C23.1736 29.7892 21.6376 29.0812 18.5683 27.6678L17.7723 27.3025C16.9003 26.8998 16.4643 26.6998 16.0016 26.6998C15.5389 26.6998 15.1029 26.8998 14.2309 27.3025L13.4363 27.6678C10.3656 29.0812 8.82962 29.7878 7.80962 29.0145C6.78695 28.2385 6.95628 26.4945 7.29362 23.0052L7.38162 22.1038C7.47762 21.1118 7.52562 20.6158 7.38162 20.1572C7.24028 19.6972 6.92162 19.3252 6.28695 18.5838L5.70828 17.9065C3.47228 15.2932 2.35495 13.9852 2.74428 12.7305C3.13495 11.4758 4.77495 11.1038 8.05495 10.3625L8.90295 10.1705C9.83495 9.95984 10.3003 9.8545 10.6749 9.5705C11.0483 9.2865 11.2883 8.85584 11.7683 7.9945L12.2056 7.2105Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/starOutline.ef7c95016460490075f978ec6f84d05d.svg";
export { ForwardRef as ReactComponent };